import { render, staticRenderFns } from "./toast-notification.vue?vue&type=template&id=528bc924"
import script from "./toast-notification.vue?vue&type=script&lang=js"
export * from "./toast-notification.vue?vue&type=script&lang=js"
import style0 from "./toast-notification.vue?vue&type=style&index=0&id=528bc924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports